import PropTypes from "prop-types";
import React from "react";
import { Modal } from "reactstrap";

// i18n
import { withTranslation } from "react-i18next";
import CustomButton from "../General/CustomButton";
import { buttonsTitles } from "common/data";
const FormModal = ({
  show,
  onSaveClick,
  onCloseClick,
  isSaving,
  children,
  t,
  modalTitle,
  modalSize,
  noFooter,
  notCentered,
  includeComputeButton,
  onComputeClick,
  hideSaveButton,
  saveButtonTitle,
  saveButtonBG,
  scrollable,
  disableSave,
}) => {
  return (
    <Modal
      size={modalSize ? modalSize : "md"}
      isOpen={show}
      toggle={onCloseClick}
      centered={notCentered ? false : true}
      backdrop="static"
      scrollable={scrollable ? scrollable : false}
    >
      <div className="modal-header">
        {/* Modal Header Title */}
        <h5 className="modal-title mt-0" id="myModalLabel">
          {modalTitle}
        </h5>

        {/* close button on the top right section */}
        <button
          type="button"
          onClick={onCloseClick}
          className="btn-close position-absolute end-0 top-0 m-3"
        ></button>
      </div>

      {/* Modal Body */}
      <div className="modal-body">{children}</div>

      {/* Modal Footer */}
      {!noFooter && (
        <div className="modal-footer">
          {hideSaveButton ? null : (
            <CustomButton
              type="button"
              // className="btn btn-danger"
              className={`btn ${
                saveButtonBG ? `btn-${saveButtonBG}` : "btn-success"
              }`}
              onClick={onSaveClick}
              disabled={isSaving || disableSave ? true : false}
              isSaving={isSaving}
              title={
                saveButtonTitle ? t(`${saveButtonTitle}`) : buttonsTitles.save
              }
            />
          )}

          {includeComputeButton ? (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onComputeClick}
              disabled={isSaving}
            >
              {t("Compute")}
            </button>
          ) : null}
        </div>
      )}
    </Modal>
  );
};

FormModal.propTypes = {
  onCloseClick: PropTypes.func,
  onSaveClick: PropTypes.func,
  show: PropTypes.any,
  isSaving: PropTypes.bool,
  children: PropTypes.any,
  // modalTitle: PropTypes.string,
  modalTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default withTranslation()(FormModal);
